import { render, staticRenderFns } from "./statusPopup.vue?vue&type=template&id=883e1b02&scoped=true&lang=pug"
import script from "./statusPopup.vue?vue&type=script&lang=js"
export * from "./statusPopup.vue?vue&type=script&lang=js"
import style0 from "./statusPopup.vue?vue&type=style&index=0&id=883e1b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883e1b02",
  null
  
)

export default component.exports